import { Box } from '@material-ui/core';
import { EducationAssetDetails, formatMoney } from '@nemuru-eng/js-api-client';

import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { DateFormField } from '@/components/shared/components/NewContextForms/DateFormField';
import { NumberFormField } from '@/components/shared/components/NewContextForms/NumberFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { Text } from '@/components/shared/components/Text';

interface EducationDetailsFormProps extends FormGridOptions {
  assetDetails: EducationAssetDetails;
}

export const EducationDetailsForm = ({ assetDetails, fullWidth, fieldVariant }: EducationDetailsFormProps) => {
  return (
    <>
      <Box pt={2}>
        <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
          <TextFormField name={'type'} label={'TYPE'} value={<Text tId={assetDetails.type} />} />
          <TextFormField name={'description'} label={'DESCRIPTION'} value={assetDetails.description} />
          <DateFormField name={'startDate'} label={'COURSE_START_DATE'} value={assetDetails.startDate} />
          <DateFormField name={'endDate'} label={'COURSE_END_DATE'} value={assetDetails.endDate} />
          <NumberFormField
            name={'value'}
            label={'TOTAL_COURSE_AMOUNT'}
            value={formatMoney({ value: assetDetails.value.amount, currency: assetDetails.value.currency }, 2)}
          />
          <NumberFormField
            name={'downPayment'}
            label={'COURSE_DOWNPAYMENT'}
            value={
              assetDetails.downPayment
                ? formatMoney(
                    { value: assetDetails.downPayment.amount, currency: assetDetails.downPayment.currency },
                    2,
                  )
                : '-'
            }
          />
          <NumberFormField
            name={'scholarship'}
            label={'SCHOLARSHIP'}
            value={
              assetDetails.scholarship
                ? formatMoney(
                    { value: assetDetails.scholarship.amount, currency: assetDetails.scholarship.currency },
                    2,
                  )
                : undefined
            }
          />
        </FormGridContainer>
      </Box>
    </>
  );
};
